export const ProductRedirectMixins = {
  computed: {
    determineRedirectRoute() {
      const currentUrl = new URL(window?.location?.href);
      switch (currentUrl?.searchParams?.get('redirect_path')) {
        case 'licensing-po':
          return 'ContinueToLicensing';
        case 'basket':
          return 'Basket';
        case 'product-interrupt':
          return 'ProductInterrupt';
        case 'store':
          return 'Store';
        case 'wallet-card-store':
          return 'WalletCardStore';
        default:
          return null;
      }
    },
  },
};
